import React, { useState } from 'react';
import { auth, firestore } from './firebase';
import { doc, getDoc, updateDoc, collection, addDoc, Timestamp } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import './Creation.css';
import Veri from './assets/VerifiedTransaction.png'


const CreateTransaction = () => {
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');
  const [title, setTitle] = useState('');
  const [type, setType] = useState('income');
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const navigate = useNavigate();

  const handleCreateTransaction = async (e) => {
    e.preventDefault();
    if (!amount || !description || !title) {
      alert('Please fill in all fields');
      return;
    }

    try {
      const user = auth.currentUser;
      const userDocRef = doc(firestore, 'users', user.uid);
      const userDoc = await getDoc(userDocRef);
      
      if (userDoc.exists()) {
        const userData = userDoc.data();
        let newBalance = userData.balance || 0;

        if (type === 'income') {
          newBalance += parseFloat(amount);
        } else if (type === 'expense') {
          newBalance -= parseFloat(amount);
        }

        // Update the user's balance
        await updateDoc(userDocRef, { balance: newBalance });

        // Create the transaction
        const transaction = {
          userId: user.uid,
          amount: parseFloat(amount),
          description,
          title,
          type,
          date: Timestamp.now()
        };
        await addDoc(collection(firestore, 'transactions'), transaction);

        // Show success modal
        setModalMessage('Transaction created successfully!');
        setShowModal(true);

        // Reset form fields
        setAmount('');
        setDescription('');
        setTitle('');
        setType('income');

        // Navigate back to dashboard after creation (optional)
        // navigate('/dashboard');
      } else {
        console.error("User document does not exist!");
        alert('User document does not exist!');
      }
    } catch (error) {
      console.error("Error creating transaction: ", error);
      setModalMessage('Failed to create transaction');
      setShowModal(true);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setModalMessage('');
  };

  return (
    <div className="create-transaction">
      <h3>Create Transaction</h3>
      <form onSubmit={handleCreateTransaction} className="create-transaction-form">
        <input
          type="number"
          placeholder="Amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
        <input
          type="text"
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <select value={type} onChange={(e) => setType(e.target.value)}>
          <option value="income">Income</option>
          <option value="expense">Expense</option>
        </select>
        <button type="submit">Create</button>
      </form>

      {showModal && (
        <div className="modal">
          <div className="modal-content">
          <img src={Veri} alt="hhk" style={{width: 60, height: 60}} />
            <p style={{width: '90%'}}>{modalMessage}</p>
            <span className="close" onClick={closeModal}>Okay</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateTransaction;
